module.exports = __webpack_public_path__ + "pc/img/planner.15564d60.webp";